// extracted by mini-css-extract-plugin
module.exports = {"selectors-wrapper":"locale-selectors_selectors-wrapper__7Malr","select-wrapper":"locale-selectors_select-wrapper__2hGnd"};